import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';

let totalSlides = document.querySelectorAll('.swiper-slide').length;
let middleSlide = Math.floor(totalSlides / 2);

Swiper.use([ Navigation, Pagination, Autoplay ]);

let defaults = {
  loop: false,
  centeredSlides: true,
  slideToClickedSlide: true,
  slidesPerView: 'auto',
  spaceBetween: 40,
  pagination: {
    enabled: true,
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    enabled: false,
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    '1920': {
      initialSlide: middleSlide,
    },
    '1640': {
      initialSlide: middleSlide,
    },
    '1280': {
      initialSlide: middleSlide,
      slidesPerView: 3.5,
    },
    '640': {
      slidesPerView: 2,
    },
    '320': {
      slidesPerView: 1.5,
    },
  },
};

initSwipers(defaults);

// Debounce function
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function updateSwiperSettings(swiperContainer, options) {
  let screenWidth = window.innerWidth;
  let swiperInstance = new Swiper(swiperContainer, options);
  const slideCount = swiperInstance.slides.length;

  if (screenWidth > 1640 && slideCount <= 4) {
    swiperInstance.destroy(true, true);
    swiperContainer.classList.remove('has-pagination--js');
  } else {
    swiperContainer.classList.add('has-pagination--js');
  }
  return swiperInstance;
}

function initSwipers(defaults = {}, selector = 'body:not(.wp-admin) .wp-block-content-slider .swiper-container') {
  let swipers = document.querySelectorAll(selector);

  swipers.forEach((swiperContainer) => {
    let optionsData = swiperContainer.dataset.swiper ? JSON.parse(swiperContainer.dataset.swiper) : {};
    let options = {
      ...defaults,
      ...optionsData,
    };

    let swiperInstance = updateSwiperSettings(swiperContainer, options);

    // Listen for resize events and debounce
    window.addEventListener('resize', debounce(() => {
      if (swiperInstance && swiperInstance.initialized) {
        swiperInstance.destroy(true, true);
      }
      swiperInstance = updateSwiperSettings(swiperContainer, options);
    }, 200));
  });
}
